{
  "name": "Commedab",
  "version": 1,
  "color": {
    "themes": [
      {
        "id": "light",
        "name": "Clair"
      },
      {
        "id": "dark",
        "name": "Sombre"
      }
    ],
    "tokens": [
      {
        "name": "ground",
        "value": {
          "light": "#F3EDE3",
          "dark": "#181410"
        },
        "usage": "Fond d'écran (lin). Tout le reste se pose dessus."
      },
      {
        "name": "surface",
        "value": {
          "light": "#FFFDFA",
          "dark": "#231E19"
        },
        "usage": "Cartes, feuilles, barre d'onglets, champ de recherche. Toujours bordé de `line` sur `ground`."
      },
      {
        "name": "surface-2",
        "value": {
          "light": "#EBE3D2",
          "dark": "#2C251E"
        },
        "usage": "Ligne en surbrillance (appui long), pastille « possédé », fond de champ, rail de la barre de progression."
      },
      {
        "name": "ink",
        "value": {
          "light": "#241F1A",
          "dark": "#F2EAE0"
        },
        "usage": "Texte principal, icônes. Sur `ground`, `surface`, `surface-2` (≥ 14:1)."
      },
      {
        "name": "ink-muted",
        "value": {
          "light": "#6E645A",
          "dark": "#A89C8E"
        },
        "usage": "Texte secondaire : sous-titres, justifications, quantités, onglets inactifs. ≥ 4.5:1 sur `ground`, `surface` et `surface-2`."
      },
      {
        "name": "line",
        "value": {
          "light": "#E3DACC",
          "dark": "#3A322B"
        },
        "usage": "Bordures décoratives : cartes, séparateurs de lignes, barre d'onglets. Jamais seule pour porter un sens."
      },
      {
        "name": "line-strong",
        "value": {
          "light": "#8F8477",
          "dark": "#7C7064"
        },
        "usage": "Bordures qui portent un sens : case à cocher vide, champ en attente de saisie. ≥ 3:1 sur `surface` et `ground`."
      },
      {
        "name": "action",
        "value": {
          "light": "#0E5B46",
          "dark": "#5FC79C"
        },
        "usage": "La couleur d'action et de « c'est sur la liste » : boutons, stepper, coche, lien, pastille recette complète, anneau de focus. Texte en `action` ≥ 4.5:1 sur `ground`, `surface`, `action-soft`."
      },
      {
        "name": "action-soft",
        "value": {
          "light": "#DDEBE4",
          "dark": "#1B3B30"
        },
        "usage": "Fond du stepper actif et de la pastille « sélectionné ». Texte dessus en `action`."
      },
      {
        "name": "on-action",
        "value": {
          "light": "#FFFFFF",
          "dark": "#0F1C17"
        },
        "usage": "Texte et icônes posés sur un fond `action` (bouton plein, coche, pastille recette complète)."
      },
      {
        "name": "alert",
        "value": {
          "light": "#AC3E29",
          "dark": "#F28A72"
        },
        "usage": "Ce qui manque et ce qui est irréversible : pastille « manquant », « Il te manque 2 ingrédients », « Supprimer », « Je n'en achète plus », erreurs. Texte en `alert` ≥ 4.5:1 sur `ground`, `surface`, `alert-soft`."
      },
      {
        "name": "alert-soft",
        "value": {
          "light": "#FAE4DC",
          "dark": "#3F2219"
        },
        "usage": "Fond de la pastille « manquant » et du bandeau d'erreur. Texte dessus en `alert`."
      },
      {
        "name": "scrim",
        "value": {
          "light": "rgba(36,31,26,0.45)",
          "dark": "rgba(0,0,0,0.55)"
        },
        "usage": "Voile sous le panneau Ajouter et les feuilles."
      },
      {
        "name": "skeleton",
        "value": {
          "light": "#E6DED1",
          "dark": "#2F2822"
        },
        "usage": "Blocs de chargement (squelettes), sur `surface`. Animation `pulse` de `duration-slow` × 4."
      }
    ]
  },
  "type": {
    "fonts": [],
    "families": {
      "display": "\"Fraunces\", Georgia, \"Times New Roman\", serif",
      "sans": "\"Manrope\", system-ui, -apple-system, \"Segoe UI\", sans-serif"
    },
    "groups": [
      {
        "name": "Titres (Fraunces, droit uniquement)",
        "family": "display",
        "styles": [
          {
            "name": "title-screen",
            "fontSize": "28px",
            "lineHeight": "34px",
            "fontWeight": 600,
            "letterSpacing": "-0.3px",
            "sample": "Ma liste",
            "usage": "Titre d'écran, une fois par écran."
          },
          {
            "name": "title-hero",
            "fontSize": "32px",
            "lineHeight": "38px",
            "fontWeight": 600,
            "letterSpacing": "-0.4px",
            "sample": "Lait",
            "usage": "Nom du produit ou de la recette sur sa fiche."
          },
          {
            "name": "title-section",
            "fontSize": "17px",
            "lineHeight": "22px",
            "fontWeight": 600,
            "sample": "Réglages",
            "usage": "Titre de section (Réglages, Historique, Notes, Tous tes produits) et nom de recette sur une carte (20px autorisé)."
          },
          {
            "name": "title-card",
            "fontSize": "20px",
            "lineHeight": "26px",
            "fontWeight": 600,
            "sample": "Carbonara",
            "usage": "Nom de recette sur une carte."
          },
          {
            "name": "sentence",
            "fontSize": "18px",
            "lineHeight": "24px",
            "fontWeight": 500,
            "sample": "Il t'en reste environ 2 bouteilles, de quoi tenir jusqu'à mardi.",
            "usage": "Phrase en langage courant : estimation de la fiche produit, titre d'un état vide, question d'une feuille de confirmation. Jamais en italique, jamais sous 18px."
          },
          {
            "name": "sentence-lg",
            "fontSize": "24px",
            "lineHeight": "30px",
            "fontWeight": 500,
            "sample": "Comme d'hab chef ?",
            "usage": "Titre des suggestions du panneau Ajouter."
          }
        ]
      },
      {
        "name": "Texte (Manrope)",
        "family": "sans",
        "styles": [
          {
            "name": "body",
            "fontSize": "16px",
            "lineHeight": "22px",
            "fontWeight": 500,
            "sample": "Pâtes",
            "usage": "Texte courant, champs de saisie."
          },
          {
            "name": "body-strong",
            "fontSize": "16px",
            "lineHeight": "22px",
            "fontWeight": 600,
            "sample": "Pâtes",
            "usage": "Nom d'un produit sur une ligne, un résultat, un ingrédient."
          },
          {
            "name": "body-sm",
            "fontSize": "14px",
            "lineHeight": "20px",
            "fontWeight": 500,
            "sample": "Lardons et crème partiront sur la liste, le reste tu l'as déjà.",
            "usage": "Phrases secondaires, libellés de réglage, historique, notes."
          },
          {
            "name": "label",
            "fontSize": "13px",
            "lineHeight": "18px",
            "fontWeight": 600,
            "sample": "5 ingrédients · il te manque 2",
            "usage": "Sous-titres de carte, compteur « 2 sur 12 », boutons compacts, valeurs de champ (700)."
          },
          {
            "name": "caption",
            "fontSize": "12px",
            "lineHeight": "16px",
            "fontWeight": 600,
            "sample": "Carbonara · 200 g",
            "usage": "Sous-titre de ligne, pastilles, badges, aide de champ."
          },
          {
            "name": "tab",
            "fontSize": "11px",
            "lineHeight": "14px",
            "fontWeight": 600,
            "sample": "Recettes",
            "usage": "Libellé d'onglet (700 quand actif)."
          },
          {
            "name": "button",
            "fontSize": "15px",
            "lineHeight": "20px",
            "fontWeight": 700,
            "sample": "Ajouter à la liste",
            "usage": "Bouton plein et bouton texte."
          },
          {
            "name": "button-sm",
            "fontSize": "13px",
            "lineHeight": "18px",
            "fontWeight": 700,
            "sample": "Ajouter",
            "usage": "Bouton contour compact, chiffre du stepper."
          }
        ]
      }
    ]
  },
  "spacing": {
    "tokens": [
      {
        "name": "space-1",
        "value": "4px",
        "usage": "Entre un nom et son sous-titre, entre icône et libellé d'onglet."
      },
      {
        "name": "space-2",
        "value": "8px",
        "usage": "Entre pastilles, entre champ et aide, padding vertical d'une rangée de pastilles."
      },
      {
        "name": "space-3",
        "value": "12px",
        "usage": "Entre une case et son texte, entre texte et contrôle d'une ligne, padding vertical d'une ligne."
      },
      {
        "name": "space-4",
        "value": "16px",
        "usage": "Gouttière d'écran (gauche/droite), padding d'une carte, entre cartes empilées (10–12 autorisé)."
      },
      {
        "name": "space-6",
        "value": "24px",
        "usage": "Au-dessus d'un titre d'écran, sous la barre d'état."
      },
      {
        "name": "space-8",
        "value": "32px",
        "usage": "Entre deux groupes de contenu indépendants (ex. estimation → Réglages)."
      }
    ]
  },
  "radius": {
    "tokens": [
      {
        "name": "radius-field",
        "value": "10px",
        "usage": "Champs de réglage, zone d'un onglet, boutons de clavier. Dit « on saisit ici »."
      },
      {
        "name": "radius-card",
        "value": "14px",
        "usage": "Cartes, bouton plein, bandeau de toast."
      },
      {
        "name": "radius-sheet",
        "value": "22px",
        "usage": "Haut du panneau Ajouter et des feuilles."
      },
      {
        "name": "radius-pill",
        "value": "999px",
        "usage": "Tout ce qui est action ou étiquette : bouton contour, stepper, pastilles, champ de recherche, badge, barre de progression."
      }
    ]
  },
  "size": {
    "note": "Hauteurs fixes des contrôles. La cible tactile minimale est 44px : un contrôle plus petit (36px) a une zone de tap étendue à 44px.",
    "tokens": [
      {
        "name": "control-sm",
        "value": "36px",
        "usage": "Bouton contour, stepper, pastille recette sur la liste (zone de tap 44px)."
      },
      {
        "name": "control",
        "value": "44px",
        "usage": "Champ de recherche, champ de saisie, zone de tap minimale."
      },
      {
        "name": "control-lg",
        "value": "48px",
        "usage": "Bouton plein (Ajouter à la liste, barre du bas)."
      },
      {
        "name": "row",
        "value": "54px",
        "usage": "Hauteur minimale d'une ligne de liste ou de résultat."
      },
      {
        "name": "checkbox",
        "value": "22px",
        "usage": "Case à cocher d'une ligne."
      },
      {
        "name": "icon",
        "value": "22px",
        "usage": "Icônes Phosphor dans la barre d'onglets et les en-têtes."
      },
      {
        "name": "icon-sm",
        "value": "16px",
        "usage": "Icône dans une pastille, la barre « Ajouter », un résultat de recherche."
      },
      {
        "name": "icon-xs",
        "value": "14px",
        "usage": "Icône devant un en-tête de rayon."
      },
      {
        "name": "icon-lg",
        "value": "40px",
        "usage": "Icône d'un état vide, en `ink-muted`."
      },
      {
        "name": "progress",
        "value": "6px",
        "usage": "Hauteur de la barre de progression."
      },
      {
        "name": "tab-bar",
        "value": "84px",
        "usage": "Barre d'onglets, zone de sécurité comprise."
      },
      {
        "name": "toggle-w",
        "value": "46px",
        "usage": "Largeur de l'interrupteur (capsule)."
      },
      {
        "name": "toggle-h",
        "value": "28px",
        "usage": "Hauteur de l'interrupteur."
      },
      {
        "name": "toggle-thumb",
        "value": "24px",
        "usage": "Pouce de l'interrupteur, centré dans la capsule."
      }
    ]
  },
  "border": {
    "tokens": [
      {
        "name": "border-thin",
        "value": "1px",
        "usage": "Cartes, séparateurs, champs."
      },
      {
        "name": "border-strong",
        "value": "1.5px",
        "usage": "Contour d'un contrôle d'action (bouton contour, stepper, champ de recherche actif)."
      },
      {
        "name": "border-focus",
        "value": "2px",
        "usage": "Anneau de focus clavier, couleur `action`, décalé de 2px."
      }
    ]
  },
  "opacity": {
    "note": "Opacités d'état, appliquées à tout le composant.",
    "tokens": [
      {
        "name": "opacity-disabled",
        "value": "0.45",
        "usage": "Contrôle ou champ désactivé (produit archivé, hors ligne dans Réglages)."
      },
      {
        "name": "opacity-pending",
        "value": "0.55",
        "usage": "Ligne écrite en local, pas encore synchronisée."
      },
      {
        "name": "opacity-busy",
        "value": "0.6",
        "usage": "Stepper en attente d'écriture."
      },
      {
        "name": "opacity-pressed",
        "value": "0.85",
        "usage": "Contrôle sous le doigt, avec `scale-pressed`, pendant `duration-fast`."
      },
      {
        "name": "opacity-pulse",
        "value": "0.55",
        "usage": "Creux du pulse des squelettes et de la barre de progression indéterminée."
      }
    ]
  },
  "scale": {
    "tokens": [
      {
        "name": "scale-pressed",
        "value": "0.97",
        "usage": "Échelle d'un bouton pressé, pendant `duration-fast`."
      }
    ]
  },
  "duration": {
    "note": "Courbe unique : ease-out (cubic-bezier(0.2, 0, 0, 1)). Respecter prefers-reduced-motion : les durées passent à 0, les changements d'état restent.",
    "tokens": [
      {
        "name": "duration-fast",
        "value": "150ms",
        "usage": "Coche, pression d'un bouton, changement de chiffre du stepper."
      },
      {
        "name": "duration-base",
        "value": "220ms",
        "usage": "Ouverture d'une feuille, du panneau Ajouter, apparition d'un toast, glissement d'une ligne."
      },
      {
        "name": "duration-slow",
        "value": "320ms",
        "usage": "Disparition d'une ligne retirée, réordonnancement, base du pulse des squelettes (× 4)."
      }
    ]
  }
}